export default __webpack_public_path__ + "static/media/digital-print-copy.edbf6799.jpg";